<template>
  <div class="move-to-excluded-confirmation-popup">
    <popup :buttons="buttonOptions"
           :back-action="back">
      <template v-slot:title>
        <span class="selected-category" :class="selectedCategory.cashflowCategory">להוציא את ה{{ incomeOrExpense }} הזו מהתזרים של החודש?</span>
      </template>
      <template v-slot:content>
        <div class="explanation">
          <div class="warning">זה אומר שה{{ incomeOrExpense }} הזאת <span class="bold">לא תופיע בחישוב התזרים של החודש!</span></div>
          <div v-if="isIncomeCategory">הכנסה לא תזרימית היא הכנסה שלא התכוונת לממן איתה את ההוצאות של החודש.</div>
          <div v-else>הוצאה לא תזרימית היא הוצאה שלא התכוונת לממן אותה מההכנסות של החודש.</div>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BaseUI from 'base-ui';
import ModalBus from '../../../../../../../../../../event-bus/modal-bus';
import ChangeTransactionCategoryPopup from './ChangeTransactionCategoryPopup.vue';
import MoveToExcludedSummaryPopup from './MoveToExcludedSummaryPopup.vue';
import Segment from '../../../../../../../../../../Segment';

export default {
  name: 'MoveToExcludedConfirmationPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  created() {
    Segment.trackUserInteraction('MoveToExcludedConfirmationPopup_Shown', {
      businessName: this.transaction.businessName,
      expenseCategory: this.transaction.expense,
      isIncomeCategory: this.isIncomeCategory,
    });
  },
  computed: {
    ...mapState('editTransaction', ['transaction']),
    ...mapGetters('editTransaction', ['selectedCategory', 'categoryToVariant', 'isIncomeCategory', 'incomeOrExpense']),
    buttonOptions() {
      return [{
        title: 'כן, להוציא מהתזרים',
        action: () => this.onSave(),
        variant: this.categoryToVariant[this.selectedCategory.cashflowCategory],
      }, {
        title: 'ביטול',
        action: () => this.close(),
        variant: 'secondary-black',
      }];
    },
  },
  methods: {
    back() {
      Segment.trackUserInteraction('MoveToExcludedConfirmationPopup_BackClicked', {
        businessName: this.transaction.businessName,
        expenseCategory: this.transaction.expense,
      });
      ModalBus.$emit('open', {
        component: ChangeTransactionCategoryPopup,
        props: {},
      });
    },
    onSave() {
      Segment.trackUserInteraction('MoveToExcludedConfirmationPopup_AnswerClicked', {
        businessName: this.transaction.businessName,
        expenseCategory: this.transaction.expense,
      });
      ModalBus.$emit('open', {
        component: MoveToExcludedSummaryPopup,
        props: {},
      });
    },
    close() {
      Segment.trackUserInteraction('MoveToExcludedConfirmationPopup_CloseClicked', {
        businessName: this.transaction.businessName,
        expenseCategory: this.transaction.expense,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../../scss/category-color-mixins';

  .move-to-excluded-confirmation-popup {

    .explanation {
      line-height: 16px;
      white-space: pre-line;
      .warning {
        color: $riseup_coral;
        margin-bottom: 16px;
        .bold {
          font-weight: bold;
        }
      }
    }
  }

</style>
